module.exports = __webpack_public_path__ + "img/img0.49add728.jpg";